// src/pages/SolicitarLinkAcesso.js
//
// Autoatendimento para o perfil ALTA GESTAO: como essas contas nunca têm
// senha, esta tela permite pedir um novo link de acesso a qualquer momento,
// de qualquer dispositivo, sem depender do ADM.ORG reenviar o convite.

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../hooks/useToast';
import { FaSpinner } from 'react-icons/fa';
import BackButton from '../components/common/BackButton/BackButton';
import { enviarLinkMagico } from '../services/magicLinkAuth';
import './RecuperarSenha.css';

const logo = '/logo_gif.gif';

const SolicitarLinkAcesso = () => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const { addToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await enviarLinkMagico(email);
      setEnviado(true);
    } catch (error) {
      console.error('[SolicitarLinkAcesso] Erro ao enviar link', error);
      addToast('Erro ao enviar o link. Confira o e-mail e tente novamente.', 'error');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="hero-section">
      <div className="hero-column-left">
        <div className="storytelling">
          <img src={logo} alt="Logo Mago" className="login-logo-main" />
          <h1 className="headline">Acesso por link. <span>Sem senha.</span></h1>
          <p className="support-text">
            Se você faz parte da Alta Gestão de uma organização, use este e-mail para receber um
            novo link de acesso — funciona em qualquer computador ou celular.
          </p>
        </div>
      </div>
      <div className="hero-column-right">
        <div className="login-form-panel">
          {enviado ? (
            <>
              <h2>Verifique seu e-mail</h2>
              <p className="form-subtitle">
                Se {email} pertence a uma conta de Alta Gestão, você vai receber um link de acesso
                em instantes. Confira também a caixa de spam.
              </p>
              <BackButton label="Voltar para o Login" onClick={() => navigate('/login')} style={{ marginTop: '1rem' }} />
            </>
          ) : (
            <>
              <h2>Acessar por link</h2>
              <p className="form-subtitle">Digite o e-mail cadastrado como Alta Gestão para receber um novo link de acesso.</p>
              <form onSubmit={handleSubmit} className="login-form">
                <div className="input-group">
                  <label htmlFor="email">E-mail</label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="seu.email@exemplo.com"
                    required
                    autoComplete="email"
                  />
                </div>
                <button type="submit" className="login-button" disabled={sending} aria-busy={sending}>
                  {sending ? (
                    <>
                      <FaSpinner className="icon-spin" />
                      <span>Enviando...</span>
                    </>
                  ) : (
                    'Enviar link de acesso'
                  )}
                </button>
              </form>
              <BackButton label="Voltar para o Login" onClick={() => navigate('/login')} style={{ marginTop: '1rem' }} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SolicitarLinkAcesso;
